export default [
	{
		path: "/admin/reports",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminReports",
		mui: true,
	},
];
